import moment from 'moment-timezone';

export const dateObject = (date) => date ? new Date(date) : null;
export const trimDate = (date) => date ? moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS') : null;

const SYLLABUS_DATE_FORMATS = ['YYYY-MM-DD', 'MMM D', 'MMM DD', 'MM/DD/YYYY'];

export const parseSyllabusDate = (date) => {
  if (!date) {
    return null;
  }

  const parsedDate = moment(date, SYLLABUS_DATE_FORMATS);

  return parsedDate.isValid() ? parsedDate : null;
};

export const formatSyllabusDate = (date, format) => {
  const parsedDate = parseSyllabusDate(date);

  return parsedDate ? parsedDate.format(format) : date || '';
};
